export default "__VITE_ASSET__CrcUTSlM__"